import * as d3 from 'd3';

export function isValidColor(color: string): boolean {
  return !!d3.color(color);
}
